import { useProcessRemittance } from 'api/action';
import { useListProvidersBySite, useListRemittanceBySite } from 'api/resource';
import { useState, useEffect } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useUserRemittanceManagementData = () => {
  const { id } = useCurrentSiteStore();
  const [processingSubmission, setProcessingSubmission] =
    useState<boolean>(false);

  const remittanceResult = useListRemittanceBySite({ siteID: id });

  const processRemittance = useProcessRemittance();

  const siteProviders = useListProvidersBySite({ siteID: id });

  useEffect(() => {
    if (processRemittance.isPending) {
      setProcessingSubmission(true);
    }
    if (processRemittance.isSuccess) {
      remittanceResult.refetch();
      setProcessingSubmission(false);
    }
    if (processRemittance.error) {
      setProcessingSubmission(false);
    }
  }, [processRemittance?.status]);

  const isLoading = remittanceResult.isLoading;
  const isError = remittanceResult.isError;
  const isFetching = remittanceResult.isFetching || processingSubmission;
  const errorMessage = remittanceResult.error?.message;

  return {
    remittances: remittanceResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
    processRemittance,
    siteProviders: siteProviders.data || [],
  };
};
